import { orgConfiguration } from "@/mixins";

function getLocaleMeta(currentLocale) {
  const baseLocale = currentLocale === "cs" ? "cs_CZ" : "en_EN";
  const alternateLocale = currentLocale === "cs" ? "en_EN" : "cs_CZ";

  return [
    {
      vmid: "og:locale",
      property: "og:locale",
      content: baseLocale
    },
    {
      vmid: "og:locale:alternate",
      property: "og:locale:alternate",
      content: alternateLocale
    }
  ];
}

export const getMeta = (self, title, description) => {
  const url = orgConfiguration(self.organizationConfig, "organization.url");
  const titleWithOrgName =
    title +
    " " +
    orgConfiguration(self.organizationConfig, "organization.name");
  return {
    titleTemplate:
      "%s " + orgConfiguration(self.organizationConfig, "organization.name"),
    title: title,
    link: [
      { rel: "alternate", hreflang: "cs-cs", href: url },
      { rel: "alternate", hreflang: "x-default", href: url + "/en" }
    ],
    meta: [
      {
        vmid: "description",
        name: "description",
        content: description
      },
      {
        vmid: "twitter:description",
        name: "twitter:description",
        content: description
      },
      {
        vmid: "twitter:card",
        name: "twitter:card",
        content: "summary_large_image"
      },
      {
        vmid: "twitter:url",
        name: "twitter:url",
        content: url
      },
      {
        vmid: "twitter:title",
        name: "twitter:title",
        content: titleWithOrgName
      },
      {
        vmid: "twitter:image",
        name: "twitter:image",
        content: `${process.env.VUE_APP_PORTAL_PATH}/../tamplete/dev-portal.png`
      },
      {
        vmid: "og:title",
        property: "og:title",
        content: titleWithOrgName
      },
      {
        vmid: "og:locale",
        property: "og:locale",
        content: "cs_CZ"
      },
      {
        vmid: "og:locale:alternate",
        property: "og:locale:alternate",
        content: "cs_CZ"
      },
      {
        vmid: "og:site_name",
        property: "og:site_name",
        content: "Apitalks"
      },
      { vmid: "og:type", property: "og:type", content: "website" },
      {
        vmid: "og:description",
        property: "og:description",
        content: description
      },
      {
        vmid: "og:url",
        property: "og:url",
        content: url
      },
      {
        vmid: "og:image",
        property: "og:image",
        content: `${process.env.VUE_APP_PORTAL_PATH}/../tamplete/dev-portal.png`
      },
      ...getLocaleMeta(self.$i18n.locale)
    ],
    htmlAttrs: {
      lang: self.$i18n.locale
    }
  };
};
